import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';

const TitleSmall = ({
  className,
  ...rest
}: HTMLAttributes<HTMLHeadingElement>) => (
  <h4 className={classNames('display-m-bold', className)} {...rest} />
);

export default TitleSmall;
